<div class="copyright">
    ©NETFOUNDRY 2025
    <a class="links" href="https://netfoundry.io/terms-and-privacy-policy/" target="_blank">Terms of Use and Privacy Policy</a>
</div>
